import { NgModule } from '@angular/core';
import { ReducersModule } from './reducers/reducers.module';

@NgModule({
  imports: [ReducersModule],
})
export class StoreModule {}
